import TeamDelete from '@/screens/TeamDelete';

export default function PrivateTeamTeamIdEditDeleteRoute() {
  return <TeamDelete />;
}
